export default (array, key) => (
  array.reduce((prev, cur, index) => {
    if (index === 0) {
      return `${key}=${cur}`;
    } else {
      return `${prev}&${key}=${cur}`;
    }
  }, '')
);
